module.exports = __webpack_public_path__ + "img/logo.acc608cd.svg";